import React, { useState } from "react";
import SecondHero from "../components/SecondHero";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

import { testos } from "../data/testos";
import { Swiper, SwiperSlide } from "swiper/react";
import { Rating } from "@mui/material";
import {
  A11y,
  Autoplay,
  Navigation,
  Pagination,
  Scrollbar,
} from "swiper/modules";
import { contactInfos } from "../data/contact-info";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import QuoteDialog from "../components/QuoteDialog";
import { content } from "../data/service-content";
import landscaping from "../assets/w1.jpg";
import lawn from "../assets/lawn.jpeg";
import tree from "../assets/tree.jpg";
import irrigation from "../assets/irrigation.jpg";
const images = {
  landscaping: landscaping,
  "lawn-care": lawn,
  tree: tree,
  irrigation: irrigation,
};
const Services = () => {
  const serviceMappings = {
    landscaping: "Landscaping",
    "lawn-care": "Lawn care",
    tree: "Tree",
    irrigation: "Irrigation",
  };
  const services = Object.keys(serviceMappings);
  const { service } = useParams();

  const [currentService, setCurrentService] = useState(service || services[0]);

  useEffect(() => {
    setCurrentService(service || services[0]);
  }, [service]);
  return (
    <div>
      <Navbar />
      <SecondHero
        title={`${serviceMappings[service]} Service`}
        breadcrumb={serviceMappings[service]}
        img={images[currentService]}
      />
      <div className="max-screen py-20 flex gap-8 flex-col-reverse lg:flex-row">
        <div className="flex-[30%] 2xl:flex-[20%]">
          <SideBarServices
            services={services}
            currentService={currentService}
            setCurrentService={setCurrentService}
            serviceMappings={serviceMappings}
          />
        </div>
        <div className="flex-[70%] 2xl:flex-[80%]">
          {" "}
          <Page service={service} serviceMappings={serviceMappings} />
        </div>
      </div>
      <Footer />
    </div>
  );
};
export default Services;
const Page = ({ service, serviceMappings }) => {
  const [currentContent, setCurrentContent] = useState();
  const [dialogState, setDialogState] = useState(false);
  const toggleDialog = (e) => {
    setDialogState((prev) => !prev);
  };
  const handleKeyClose = (e) => {
    if (e.key === "Escape") {
      setDialogState(false);
      document.body.style.overflow = "auto";
    }
  };

  return (
    <div className="" onKeyDown={(e) => handleKeyClose(e)}>
      {" "}
      <QuoteDialog state={dialogState} toggle={toggleDialog} />{" "}
      <div className="   lg:px-8 flex flex-col gap-10">
        <h3 className="text-4xl 2xl:text-5xl font-bold">
          Professional {serviceMappings[service]} Services
        </h3>

        {content[service]?.map((item, index) => {
          return (
            <div key={index} className="flex flex-col gap-2">
              <h4 className="text-xl text-neutral-1 font-medium">
                {item.title}
              </h4>
              <p className="text-neutral-3">{item.text}</p>
            </div>
          );
        })}
        <div
          onClick={toggleDialog}
          className="flex items-center gap-4 flex-wrap mt-4">
          <button className="btn btn-main">Get a Quote</button>
        </div>
      </div>
    </div>
  );
};

const SideBarServices = ({
  services,
  setCurrentService,
  currentService,
  serviceMappings,
}) => {
  const navigate = useNavigate();
  return (
    <aside className="flex flex-col gap-8">
      <div className="flex flex-col gap-4 w-full">
        <h3 className="text-3xl"> Services</h3>
        <div className="flex flex-col gap-2 divide-y items-start justify-start w-full">
          {services.map((item, index) => {
            return (
              <button
                key={index}
                onClick={() => {
                  setCurrentService(item);
                  navigate(`/services/${item}`);
                }}
                className={`capitalize text-xl text-start w-full py-2 hover:text-secondary ${
                  item === currentService && "text-primary font-semibold"
                }`}>
                {serviceMappings[item]}
              </button>
            );
          })}
        </div>
      </div>
      <div className="lg:max-w-[400px]">
        <Swiper
          slidesPerView={1}
          spaceBetween={24}
          breakpoints={{
            640: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 1,
            },
          }}
          pagination={{
            clickable: true,
          }}
          loop={true}
          autoplay={{
            delay: 3000,
          }}
          modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
          className="testo-slide">
          {testos.map((item, index) => {
            return (
              <SwiperSlide key={index} className="lg:!shadow-none">
                <SingleSlide {...item} />
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
      <div
        className="px-4 sm:px-8 bg-primary py-8 text-white  rounded-2xl"
        style={{ flex: "1 0 40%" }}>
        <h3 className="text-4xl font-semibold text-white  mb-2">
          Professional & Reliable
        </h3>
        <p className="text-white mb-4 opacity-75">
          We're open for any suggestion or just to have a chat!
        </p>
        <div className="pt-6">
          <ul className="flex flex-col gap-6">
            {contactInfos.map((item, index) => {
              return (
                <li key={index}>
                  <div className="flex  gap-4 items-center">
                    {" "}
                    <div>
                      <span className="h-12 w-12 xs:w-16 xs:h-16 rounded-[50%] border border-[rgba(255,255,255,0.4)] flex justify-center items-center ">
                        {item.icon}
                      </span>
                    </div>
                    <div className="">
                      {item.title} :{" "}
                      <span className="opacity-75">{item.text}</span>
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </aside>
  );
};
const SingleSlide = (item) => {
  return (
    <div className=" rounded-2xl  lg:border ">
      <blockquote className=" flex flex-col gap-4 justify-between p-4">
        <div className="flex items-center gap-2 xl:gap-4">
          <img
            alt={item.name}
            src={item.image}
            className="h-16 w-16 rounded-full object-cover"
          />
          <div className="ml-4 text-sm">
            <p className="font-bold text-xl text-dark-blue">{item.name}</p>
            <p className="mt-1 text-[18px]">{item.position}</p>
          </div>
        </div>
        <Rating name="read-only" value={item.rating} readOnly />
        <div>
          <p className="relative mt-4 text-gray-500 xl:text-xl">
            {item.description}
          </p>
        </div>
      </blockquote>
    </div>
  );
};
